__turbopack_context__.v({
  "header-content-mobile": "header-content-mobile-module-scss-module__wdJxRa__header-content-mobile",
  "header-content-mobile__logo-container": "header-content-mobile-module-scss-module__wdJxRa__header-content-mobile__logo-container",
  "header-content-mobile__notifications-modal-trigger-container": "header-content-mobile-module-scss-module__wdJxRa__header-content-mobile__notifications-modal-trigger-container",
  "language-button": "header-content-mobile-module-scss-module__wdJxRa__language-button",
  "language-button__icon": "header-content-mobile-module-scss-module__wdJxRa__language-button__icon",
});
